import React, { useState } from 'react';
import SupportFdsWrapper from '../../../support/components/support-fds-wrapper/support-fds-wrapper';
import { BreadcrumbsReimagine } from '../../sections/breadcrumbs-reimagine/breadcrumbs-reimagine';
import { ViewportUtil } from '../../utils/viewport-util/viewport-util';
import EllipsesIcon from '../../../assets/ellipses-image.svg';

interface Props {
    currentPage: string;
    hashId: string;
    type?: string;
    className?: string;
    title?: React.ReactNode;
    hideFirstBreadcrumb?: boolean;
    breadcrumbName?: string;
    openInNewTab?: boolean;
    rootRedirectUrl?: string;
}

export const BreadcrumbWrapperReimagine = (props: Props) => {
    const {
        currentPage,
        hashId,
        className,
        type,
        hideFirstBreadcrumb,
        breadcrumbName,
        openInNewTab,
        rootRedirectUrl,
    } = props;
    const [showMoreInfo, setShowMoreInfo] = useState<boolean>(false);

    const { isMobileView } = ViewportUtil();

    const handleShowMoreInfo = () => {
        setShowMoreInfo(!showMoreInfo);
    };

    const getMobileDevice = (title: any) => {
        return (
            <>
                {showMoreInfo
                    ? title
                    : title && (
                          <span
                              onClick={handleShowMoreInfo}
                              className="ellipses-icon"
                          >
                              <img src={EllipsesIcon} />
                          </span>
                      )}
                {!showMoreInfo && title && (
                    <span className="back-slash">{'/'}</span>
                )}
            </>
        );
    };

    const handleClick = () => {
        sessionStorage.removeItem('selectedVin');
        if (hashId === 'towing') {
            window.location.href = 'https://www.ford.com/towing/';
        }
        if (hashId === 'account' && rootRedirectUrl) {
            if (openInNewTab) {
                window.open(rootRedirectUrl, '_blank');
            } else {
                window.location.href = rootRedirectUrl;
            }
        }
    };

    return (
        <>
            <SupportFdsWrapper className={className}>
                <div className={`breadcrumbs-wrapper breadcrumbAccordion`}>
                    <BreadcrumbsReimagine
                        currentPage={currentPage}
                        hashId={hashId}
                        type={type}
                        onClick={handleClick}
                        hideFirstBreadcrumb={hideFirstBreadcrumb}
                        isShowMoreInfo={showMoreInfo}
                        breadcrumbName={breadcrumbName}
                    >
                        {!isMobileView
                            ? props?.title
                            : getMobileDevice(props?.title)}
                    </BreadcrumbsReimagine>
                </div>
            </SupportFdsWrapper>
        </>
    );
};
